
// @ts-nocheck
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import { addDays, getDay, startOfToday, endOfWeek, startOfTomorrow, min } from 'date-fns';
import { enUS, es } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import dayjs from "dayjs";
registerLocale('es', es);
registerLocale('en', enUS);
const normalizeDays = (day) => (day === 0 ? 7 : day);
const rotateDay = (day) => (day === 0 ? 1 : day === 6 ? 0 : day + 1);

const CalendarTour = ({ title, date, handleChange, cutOff = 0, availableDays = [], compact = false }) => {

    const { t, i18n } = useTranslation(['components']);
    const datePickerLocale = i18n.language?.toLowerCase().startsWith('es') ? 'es' : 'en';
    const shouldDisableDate = (date) => {
        if (!date) return false; // Manejo seguro por si date es null
        const available = Array.isArray(availableDays)
            ? availableDays.map(Number)
            : String(availableDays).split(',').map(Number); // [1, 2, 3]
        const dayOfWeek = rotateDay(date.day()); // 0 = domingo, 1 = lunes, ...
        const isDayDisabled = !available.includes(dayOfWeek);
        const cutoffTime = dayjs().add(cutOff, 'hours');
        const isAfterCutoff = date.isBefore(cutoffTime, 'day');


        return isDayDisabled || isAfterCutoff;
    };


    // If compact is requested (e.g. inside UpdateTourModal), render a minimal inline calendar
    if (compact) {
        return (
            <div style={{ padding: 0, margin: 0 }}>
                <div className="datepicker-container" style={{ minHeight: '200px' }}>
                    {/* @ts-ignore */}
                    <DatePicker
                        selected={date ? date.toDate() : null}
                        onChange={(d) => handleChange(d ? dayjs(d) : null)}
                        selectsRange={false}
                        inline
                        locale={datePickerLocale}
                        calendarStartDay={1}
                        filterDate={(d) => !shouldDisableDate(dayjs(d))}
                        minDate={new Date()}
                    />
                </div>
            </div>
        );
    }

    return (<Accordion defaultExpanded sx={{ mb: '25px', borderRadius: '8px', margin: '2px 0px', minHeight: '10px' }}>
        <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls={`${title}-content`}
            id={`${title}-header`}
            sx={{ minHeight: '20px', margin: '2px 0px' }}
        >
            <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <div className="datepicker-container" style={{ minHeight: '200px' }}>
                {/* @ts-ignore */}
                <DatePicker
                    selected={date ? date.toDate() : null}
                    onChange={(d) => handleChange(d ? dayjs(d) : null)}
                    selectsRange={false}
                    inline
                    locale={datePickerLocale}
                    calendarStartDay={1}
                    filterDate={(d) => !shouldDisableDate(dayjs(d))}
                    minDate={new Date()}
                />
            </div>
        </AccordionDetails>
    </Accordion>)
}

export const CalendarFilter = ({ title, onChange }) => {
    const { t, i18n } = useTranslation(['components']);
    const datePickerLocale = i18n.language?.toLowerCase().startsWith('es') ? 'es' : 'en';
    const [dateRange, setDateRange] = useState([null, null]);
    const [key, setKey] = useState(0);
    const [startDate, endDate] = dateRange;

    const updateRange = (newRange) => {
        setDateRange(newRange);
        if (onChange) {
            onChange(newRange);
        }
    };

    const handleQuickRange = (range) => {
        const today = startOfToday();
        const day = getDay(today);
        let newRange = [null, null];
        let isRange = true; // Flag para saber si es rango o solo día

        switch (range) {
            case 'today':
                newRange = [today, null]; // Día único
                isRange = false;
                break;
            case 'tomorrow':
                newRange = [addDays(today, 1), null]; // Día único
                isRange = false;
                break;
            case 'weekend': {
                let fridayOffset = 5 - day;
                if (fridayOffset < 0) {
                    fridayOffset += 7;
                }
                const friday = addDays(today, fridayOffset);
                const sunday = addDays(friday, 2);
                newRange = [friday, sunday];
                break;
            }
            default:
                break;
        }

        // Reiniciar estado
        setKey((prev) => prev + 1);

        // ⚡ Aplica nuevo rango o fecha única
        setTimeout(() => {
            setDateRange(newRange);
        }, 0);
    };



    return (
        <Accordion defaultExpanded sx={{ mb: '25px', borderRadius: '8px' }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls={`${title}-content`}
                id={`${title}-header`}
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ height: '340px' }}>
                <div className="datepicker-container" style={{ minHeight: '200px' }}>
                    <DatePicker
                        key={key}
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        locale={datePickerLocale}
                        onChange={(update) => {
                            setDateRange(update);
                            if (onChange) onChange(update);
                        }}
                        inline
                        calendarStartDay={1}
                    />

                    <div className="quick-buttons">
                        <button onClick={() => handleQuickRange('today')}>{t('today')}</button>
                        <button onClick={() => handleQuickRange('tomorrow')}>{t('tomorrow')}</button>
                        <button onClick={() => handleQuickRange('weekend')}>{t('weekend')}</button>
                    </div>
                </div>
            </AccordionDetails>
        </Accordion>
    );
};

export default CalendarTour;
